import axios from '../../axios/index.js'
import store from '../../../store/store.js'


export default {
   
    getAllTenants(sortBy, sortOrder, pageNumber, pageSize) {
        return axios.get('/api/tenants', { params : {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sortBy: sortBy,
            sortOrder: sortOrder,
            
        }})
    },

    getAllSignatories(tenantsId) {
        return axios.get(`/api/tenants/signatories/${tenantsId}`)
    },
    
}